import { render, staticRenderFns } from "./DashboardDetailUser.vue?vue&type=template&id=6f52ffd9"
import script from "./DashboardDetailUser.vue?vue&type=script&lang=js"
export * from "./DashboardDetailUser.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetailUser.vue?vue&type=style&index=0&id=6f52ffd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports